import { Navigate, Outlet, useOutletContext } from "react-router-dom";
import { useSelector } from "react-redux";
import useSessionMonitor from "../hooks/useSessionMonitor";
import { roles } from "../constants/commonConstants";

export const ProtectAdminRoute = () => {
  const { isAuthenticated, role } = useSelector((state) => state.auth);
  const context = useOutletContext(); 
  useSessionMonitor();

  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }

  if (role !== roles.ADMIN) {
    return <Navigate to="/" replace />;
  }
  
  return <Outlet context={context} />;
};

export const ProtectRemixerRoute = () => {
  const { isAuthenticated, role } = useSelector((state) => state.auth);
  const context = useOutletContext(); 
  useSessionMonitor();

  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }

  if (role !== roles.REMIXER) {
    return <Navigate to="/" replace />;
  }
  
  return <Outlet context={context} />;
};

export const ProtectCommonRoute = () => {
  const { isAuthenticated, role } = useSelector((state) => state.auth);
  const context = useOutletContext(); 
  useSessionMonitor();

  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }
  if (role !== roles.ADMIN && role !== roles.REMIXER) {
    return <Navigate to="/" replace />;
  }
  
  return <Outlet context={context} />;
};

// Original ProtectedRoute for backwards compatibility
export const ProtectedRoute = () => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  const context = useOutletContext(); 
  useSessionMonitor();
  
  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }
  
  return <Outlet context={context} />;
};

export const PublicRoute = () => {
  const context = useOutletContext();
  
  return <Outlet context={context} />;
};